import AppLayout from '../../components/AppLayout';
import LoginRegisterBody from '../../components/LoginRegisterBody';
import ResetPasswordForm from '../../components/ResetPasswordForm';

export default function ResetPasswordPage() {
  return (
    <AppLayout>
      <LoginRegisterBody>
        <ResetPasswordForm />
      </LoginRegisterBody>
    </AppLayout>
  );
}
